export const normalizeMenuData = (raw) => {
    if (!raw) return raw;

    // Deep clone to avoid mutating original response
    let data;
    try {
        data = JSON.parse(JSON.stringify(raw));
    } catch (e) {
        data = Object.assign({}, raw);
    }

    const normalizeTag = (t) => {
        if (t === null || t === undefined) return '';
        if (typeof t === 'string') return t;
        if (typeof t === 'object') return t.name || t.Name || t.id || t.Id || t.logoUrl || JSON.stringify(t);
        return String(t);
    };

    const normalizeItem = (item) => {
        if (!item) return item;
        if (item.tags && Array.isArray(item.tags)) {
            item.tags = item.tags.map(normalizeTag).filter(Boolean);
        }
        if (item.variants && Array.isArray(item.variants)) {
            item.variants = item.variants.map(v => ({
                id: v.id || v.Id || '',
                name: v.name || v.Name || '',
                price: v.price || v.Price || 0,
                isActive: v.isActive !== undefined ? v.isActive : (v.IsActive !== undefined ? v.IsActive : true)
            }));
        }
        return item;
    };

    (data.menus || []).forEach(menu => {
        (menu.categories || []).forEach(cat => {
            (cat.items || []).forEach(item => normalizeItem(item));
        });

        if (menu.uncategorizedItems && Array.isArray(menu.uncategorizedItems)) {
            menu.uncategorizedItems.forEach(item => normalizeItem(item));
        }
    });

    return data;
};

export default normalizeMenuData;

export const normalizePrintData = (raw) => {
    if (!raw) return raw;

    // If already in expected shape, just normalize nested properties
    if (raw.restaurant && raw.menus) {
        return normalizeMenuData(raw);
    }

    // Handle PascalCase (Restaurant/Menu) OR camelCase with singular menu
    if (raw.Restaurant || raw.Menu || raw.menu) {
        const r = raw.Restaurant || raw.restaurant || {};
        const menu = raw.Menu || raw.menu || {};

        const mapItem = (it) => ({
            id: it.Id || it.id || '',
            name: it.Name || it.name || 'Unnamed Item',
            description: it.Description || it.description || '',
            price: it.Price || it.price || 0,
            imageUrl: it.ImageUrl || it.imageUrl || '',
            isAvailable: it.IsAvailable !== undefined ? it.IsAvailable : (it.isAvailable !== undefined ? it.isAvailable : true),
            isVeg: it.IsVeg !== undefined ? it.IsVeg : (it.isVeg !== undefined ? it.isVeg : false),
            variants: ((it.Variants || it.variants) || []).map(v => ({
                id: v.Id || v.id || '',
                name: v.Name || v.name || '',
                price: v.Price || v.price || 0,
                isActive: v.IsActive !== undefined ? v.IsActive : (v.isActive !== undefined ? v.isActive : true)
            })),
            tags: ((it.Tags || it.tags) || []).map(t => (t.Name || t.name || t)).filter(Boolean)
        });

        const categories = ((menu.Categories || menu.categories) || []).map(c => ({
            id: c.Id || c.id || '',
            name: c.Name || c.name || 'Category',
            displayOrder: c.DisplayOrder || c.displayOrder || 0,
            items: ((c.Items || c.items) || []).map(mapItem)
        }));

        const normalized = {
            restaurant: {
                id: r.Id || r.id || '',
                name: r.Name || r.name || 'Restaurant',
                description: r.Description || r.description || '',
                address: r.Address || r.address || '',
                phoneNumber: r.PhoneNumber || r.phoneNumber || '',
                email: r.Email || r.email || '',
                logoUrl: r.LogoUrl || r.logoUrl || '',
                establishedYear: r.EstablishedYear || r.establishedYear || '',
                tagline: r.Tagline || r.tagline || '',
                footerText: r.FooterText || r.footerText || ''
            },
            menus: [
                {
                    id: menu.Id || menu.id || '',
                    name: menu.Name || menu.name || 'Menu',
                    description: menu.Description || menu.description || '',
                    categories,
                    uncategorizedItems: ((menu.UncategorizedItems || menu.uncategorizedItems) || []).map(mapItem)
                }
            ]
        };

        // Apply generic normalization (tags objects -> strings, variants shape)
        return normalizeMenuData(normalized);
    }

    // Fallback: try to normalize whatever structure we have
    return normalizeMenuData(raw);
};
